(function () {
  'use strict';

  class FaqTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      if (!this.tabs.length) return;
      this.classList.add('is-ready');
      this.querySelectorAll('[data-panel-hidden]').forEach(function (panel) {
        panel.hidden = true;
      });
      this.tabs.forEach(
        function (tab, index) {
          tab.addEventListener('click', this.select.bind(this, index, false));
          tab.addEventListener(
            'keydown',
            function (event) {
              var next = null;
              if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
              if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
              if (event.key === 'Home') next = 0;
              if (event.key === 'End') next = this.tabs.length - 1;
              if (next !== null) {
                event.preventDefault();
                this.select(next, true);
              }
            }.bind(this)
          );
        }.bind(this)
      );
    }

    select(index, focus) {
      this.tabs.forEach(function (tab, i) {
        var selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      if (focus) this.tabs[index].focus();
      if (window.matchMedia('(max-width: 989px)').matches) {
        var active = document.getElementById(this.tabs[index].getAttribute('aria-controls'));
        if (active) active.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
  }

  if (!customElements.get('faq-tabs')) customElements.define('faq-tabs', FaqTabs);
})();
